module.exports = __webpack_public_path__ + "first-5_paper.jpg?7d398412c84b7f60825852e336b01a98";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-5_paper.jpg
// module id = 586
// module chunks = 0